var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, copyDefault, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && (copyDefault || key !== "default"))
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toESM = (module2, isNodeMode) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", !isNodeMode && module2 && module2.__esModule ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
var __toCommonJS = /* @__PURE__ */ ((cache) => {
  return (module2, temp) => {
    return cache && cache.get(module2) || (temp = __reExport(__markAsModule({}), module2, 1), cache && cache.set(module2, temp), temp);
  };
})(typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : 0);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  Button: () => Button,
  ButtonGroup: () => ButtonGroup,
  FloatingActionButton: () => FloatingActionButton,
  IconButton: () => IconButton
});

// src/Button.tsx
var import_react = require("@chakra-ui/react");
var import_spor_i18n_react = require("@vygruppen/spor-i18n-react");
var import_spor_loader_react = require("@vygruppen/spor-loader-react");
var import_react2 = __toESM(require("react"));
var Button = (0, import_react.forwardRef)((_a, ref) => {
  var _b = _a, {
    width,
    size = "md",
    variant = "primary",
    children,
    isLoading,
    isDisabled,
    leftIcon,
    rightIcon
  } = _b, props = __objRest(_b, [
    "width",
    "size",
    "variant",
    "children",
    "isLoading",
    "isDisabled",
    "leftIcon",
    "rightIcon"
  ]);
  const ariaLabel = useCorrectAriaLabel(props);
  return /* @__PURE__ */ import_react2.default.createElement(import_react.Button, __spreadProps(__spreadValues({}, props), {
    size,
    variant,
    ref,
    "aria-label": ariaLabel,
    "aria-busy": isLoading,
    isDisabled: isDisabled || isLoading,
    leftIcon: isLoading && leftIcon ? /* @__PURE__ */ import_react2.default.createElement(import_react.Box, {
      visibility: isLoading ? "hidden" : "visible"
    }, leftIcon) : leftIcon,
    rightIcon: isLoading && rightIcon ? /* @__PURE__ */ import_react2.default.createElement(import_react.Box, {
      visibility: isLoading ? "hidden" : "visible"
    }, rightIcon) : rightIcon,
    position: "relative"
  }), isLoading && /* @__PURE__ */ import_react2.default.createElement(import_react.Center, {
    position: "absolute",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0"
  }, /* @__PURE__ */ import_react2.default.createElement(import_spor_loader_react.ColorInlineLoader, {
    maxWidth: sizeToWidthMap[size] || "4rem",
    width: "100%",
    mx: 2
  })), /* @__PURE__ */ import_react2.default.createElement(import_react.Box, {
    visibility: isLoading ? "hidden" : "visible"
  }, children));
});
var sizeToWidthMap = {
  xs: "4rem",
  sm: "4rem",
  md: "5rem",
  lg: "6rem"
};
function useCorrectAriaLabel(props) {
  var _a;
  const { t } = (0, import_spor_i18n_react.useTranslation)();
  if (props.isLoading) {
    return (_a = props.loadingText) != null ? _a : t(texts.loadingText);
  }
  return props["aria-label"];
}
var texts = {
  loadingText: {
    nb: "Laster\u2026",
    en: "Loading\u2026",
    sv: "Laddar\u2026"
  }
};

// src/ButtonGroup.tsx
var import_react3 = require("@chakra-ui/react");
var import_react4 = __toESM(require("react"));
var ButtonGroup = (props) => /* @__PURE__ */ import_react4.default.createElement(import_react3.ButtonGroup, __spreadValues({}, props));

// src/IconButton.tsx
var import_react5 = require("@chakra-ui/react");
var import_spor_loader_react2 = require("@vygruppen/spor-loader-react");
var import_react6 = __toESM(require("react"));
var IconButton = (0, import_react5.forwardRef)((_a, ref) => {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ import_react6.default.createElement(import_react5.IconButton, __spreadProps(__spreadValues({}, props), {
    spinner: /* @__PURE__ */ import_react6.default.createElement(import_spor_loader_react2.Spinner, {
      m: 1
    }),
    ref
  }));
});

// src/FloatingActionButton.tsx
var import_react7 = require("@chakra-ui/react");
var import_framer_motion = require("framer-motion");
var import_react8 = __toESM(require("react"));
var MotionBox = (0, import_framer_motion.motion)(import_react7.Box);
var FloatingActionButton = (_a) => {
  var _b = _a, {
    children,
    icon,
    variant,
    isTextVisible: externalIsTextVisible,
    placement = "bottom right"
  } = _b, props = __objRest(_b, [
    "children",
    "icon",
    "variant",
    "isTextVisible",
    "placement"
  ]);
  const [isTextVisible, setIsTextVisible] = import_react8.default.useState(externalIsTextVisible !== void 0 ? externalIsTextVisible : true);
  const scrollDirection = useScrollDirection();
  import_react8.default.useEffect(() => {
    if (externalIsTextVisible !== void 0) {
      return;
    }
    const id = window.setTimeout(() => setIsTextVisible(scrollDirection !== "down"), 1e3);
    return () => window.clearTimeout(id);
  }, [scrollDirection, externalIsTextVisible]);
  import_react8.default.useEffect(() => {
    setIsTextVisible(!!externalIsTextVisible);
  }, [externalIsTextVisible]);
  const style = (0, import_react7.useMultiStyleConfig)("FloatingActionButton", {
    variant,
    isTextVisible,
    placement
  });
  return /* @__PURE__ */ import_react8.default.createElement(MotionBox, __spreadValues({
    __css: style.container,
    as: "button"
  }, props), /* @__PURE__ */ import_react8.default.createElement(import_react7.Box, {
    __css: style.icon
  }, icon), /* @__PURE__ */ import_react8.default.createElement(MotionBox, {
    animate: isTextVisible ? "show" : "hide",
    initial: "show",
    variants: {
      show: {
        opacity: 1,
        width: "auto",
        visibility: "visible"
      },
      hide: {
        opacity: 0,
        width: 0,
        visibility: "hidden"
      }
    },
    __css: style.text
  }, children));
};
var useScrollDirection = () => {
  const [scrollDirection, setScrollDirection] = import_react8.default.useState(null);
  const lastScrollPosition = import_react8.default.useRef(window.scrollY);
  import_react8.default.useEffect(() => {
    const onScroll = () => {
      const delta = window.scrollY - lastScrollPosition.current;
      if (delta === 0) {
        return;
      }
      lastScrollPosition.current = window.scrollY;
      setScrollDirection(delta > 0 ? "down" : "up");
    };
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [scrollDirection]);
  return scrollDirection;
};
module.exports = __toCommonJS(src_exports);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Button,
  ButtonGroup,
  FloatingActionButton,
  IconButton
});
